/*!

 =========================================================
 * Paper Dashboard - v1.1.2
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2017 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

import $ from "jquery";


let window_width, div,isMenuOpen;
$(document).ready(function () {
    isMenuOpen = false;
    window_width = $(window).width();
    $("body").on("click", ".navbar-toggle", function () {
        if (isMenuOpen) {
            $(".sidebar").hide();
            $('html').removeClass('nav-open');
            $("#bodyClick").remove();
            isMenuOpen = false;
            setTimeout(function () {
                $('.navbar-toggle').removeClass('toggled');
            }, 100);
        } else {
            $(".sidebar").show();
            $('.navbar-toggle').addClass('toggled');
            div = '<div id="bodyClick"></div>';
            isMenuOpen = true;
        }
    });
});


// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
    };
};
